// Help and training (18 §18.4): a staff member took a walkthrough, to the end or closed it early.
import { z } from 'zod';
import { WALKTHROUGH_ID, WALKTHROUGH_MODES, WALKTHROUGH_OUTCOMES } from '@ecobox/domain';
import { defineCommand } from '../define';

export const recordWalkthrough = defineCommand({
  type: 'recordWalkthrough',
  permission: 'help.training',
  principals: [],
  offline: true,
  payload: z
    .object({
      walkthroughId: z.string().regex(WALKTHROUGH_ID, 'Invalid walkthrough id'),
      version: z.number().int().min(1).max(999),
      outcome: z.enum(WALKTHROUGH_OUTCOMES),
      mode: z.enum(WALKTHROUGH_MODES),
    })
    .strict(),
});

export const HELP_COMMANDS = { recordWalkthrough } as const;
